import { cpfMask } from '@/app/utils/cpfFormater'
import { Button } from '@/view/components/ui/button'
import { useCreditBalanceFormController } from './useCreditBalanceFormController'
import { User, Calendar, IdCard, CircleAlert, Phone } from 'lucide-react'
import { FormCreditData } from '../../useCreditController'
import CreditSellerCard from '../CreditSellerCard'
import { Input } from './Input'
import { phoneMask } from '@/app/utils/phoneFormater'

const CreditBalanceForm = ({
  onSubmit,
  isPending,
}: {
  onSubmit: (data: FormCreditData) => void
  isPending: boolean
}) => {
  const { methods } = useCreditBalanceFormController()

  return (
    <div className="flex w-full flex-col items-center justify-center bg-white01 px-6 py-4 sm:py-6 md:py-8">
      <CreditSellerCard />
      <div className="w-full max-w-[571px] rounded-2xl border border-gray02 bg-white01 px-4 py-6 sm:px-5 sm:py-8">
        <h2 className="text-bae mb-2 font-bold text-black01 sm:text-lg">
          Consulte e saque seu FGTS disponível
        </h2>
        <p className="text-black06 mb-4 text-xs font-medium sm:mb-6 sm:text-base">
          Insira seus dados para simular e <br className="hidden sm:block" />
          resgatar o valor disponivel do FGTS
        </p>
        <div className="flex items-start gap-2 rounded-[20px] bg-primary/10 px-4 py-4 sm:items-center sm:gap-3 sm:px-6 sm:py-5">
          <CircleAlert className="h-8 w-8 flex-shrink-0 text-primary sm:h-12 sm:w-12" />
          <span className="text-xs font-medium text-primary sm:text-base">
            Para continuar a simulação, autorize os seguintes bancos no
            aplicativo da Caixa: <b>Q.I. Sociedade de Crédito</b>, <b>J17</b> e
            <b> Singulare Corretora de Títulos.</b>
          </span>
        </div>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          className="flex flex-col gap-3 pt-4 sm:gap-4 sm:pt-5"
        >
          <Input
            name="name"
            label="Nome completo"
            icon={<User className="mr-1 h-4 w-4 text-black03 sm:h-5 sm:w-5" />}
            error={methods.formState.errors.name?.message}
            placeholder="Insira seu nome completo"
          />

          <Input
            label="Telefone"
            name="phone"
            icon={
              <Phone className="mr-1 h-4 w-4 sm:h-5 sm:w-5" color="#5F6368" />
            }
            placeholder="Insira seu telefone"
            error={methods.formState.errors.phone?.message}
            onInput={phoneMask}
          />

          <Input
            icon={
              <IdCard className="mr-1 h-3 w-3 text-black03 sm:h-4 sm:w-4" />
            }
            label="CPF"
            name="cpf"
            error={methods.formState.errors.cpf?.message}
            placeholder="Insira seu cpf"
            onInput={cpfMask}
          />

          <Input
            icon={
              <Calendar className="mr-1 h-4 w-4 text-black03 sm:h-5 sm:w-5" />
            }
            label="Data de nascimento"
            name="birthDate"
            error={methods.formState.errors.birthDate?.message}
            type="date"
            placeholder="00/00/0000"
          />

          <Button
            type="submit"
            disabled={isPending}
            className="h-12 w-full rounded-full bg-primary text-base font-bold text-white01 transition-all hover:bg-primary hover:brightness-110 sm:h-14 sm:text-lg"
          >
            {isPending ? 'Consultando...' : 'Consultar'}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default CreditBalanceForm
